module.exports = __webpack_public_path__ + "staticcomp/img/share.0643a1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/10/share.jpg
// module id = dq+d
// module chunks = 39